/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: ce514e4b1e49
 */

import * as z from "zod";

export type StreamingProfileCreate = {
  name: string;
  display_name?: string | null | undefined;
  representations: string;
};

export const StreamingProfileCreate$zodSchema: z.ZodType<
  StreamingProfileCreate
> = z.object({
  display_name: z.string().nullable().optional().describe(
    "The display name of the streaming profile",
  ),
  name: z.string().describe("The name of the streaming profile"),
  representations: z.string().describe(
    "A JSON string containing the list of representations with transformation parameters as strings",
  ),
});
